import type { VoidFunctionComponent } from 'react';

import { ignoredAtFromProjects, ignoredKindsFromProjects } from '../../../../helpers/issuesV2';
import { LICENSING_ISSUE_CONFIG } from '../../../../shared/issuesV2/issueConfig';
import { Badge } from '../../../generic';
import type { LicensingIssue } from '../../../../../shared/issuesV2';

import BaseIssueItem from './BaseIssueItem';
import NonVulnerabilityIssueItemContent from './BaseIssueItem/NonVulnerabilityIssueItemContent';

type LicenseIssueItemProps = {
  issue: LicensingIssue;
};

/**
 * Represents a Licensing issue item.
 */
const LicenseIssueItem: VoidFunctionComponent<LicenseIssueItemProps> = ({ issue }) => {
  const { color, icon, label } = LICENSING_ISSUE_CONFIG[issue.type] || {};
  const badge = (
    <Badge color={color} icon={icon}>
      {label}
    </Badge>
  );

  return (
    <BaseIssueItem
      id={issue.id}
      issue={issue}
    >
      <NonVulnerabilityIssueItemContent
        issue={issue}
        locator={issue.source.id}
        title={issue.type === 'unlicensed_dependency' ? 'No license found' : issue.license}
        createdAt={issue.createdAt}
        ignoredAt={ignoredAtFromProjects(issue.projects)}
        dependency={issue.source.name}
        version={issue.source.version}
        tickets={issue.jiraTickets}
        packageManager={issue.source.packageManager}
        depths={issue.depths}
        badge={badge}
        ignoredKinds={ignoredKindsFromProjects(issue.projects)} />
    </BaseIssueItem>
  );
};

export default LicenseIssueItem;
